import _ from "lodash";
import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  brands,
  categories,
  segments,
  persons,
  mediagroups
} from "data/actions";
import RaisedButton from "material-ui/RaisedButton";
import { Page, PageSection, PageBlock, RightDrawer } from "components/Page";
import SelectField from "material-ui/SelectField";
import MenuItem from "material-ui/MenuItem";

import Subheader from "material-ui/Subheader";
import Row from "components/Form/Row";
import MenuLink from "components/Navigation/MenuLink";
import ImageField from "components/Form/ImageField";

import CategoryLinks from "components/Lists/CategoryLinks";
import BrandChannelEditor from "components/Form/BrandChannelEditor";
import DeleteButton from "components/Buttons/DeleteButton";

import Field from "components/Form/Field";
import DropdownField from "components/Form/DropdownField";
import ToggleField from "components/Form/ToggleField";
import ChipField from "components/Form/ChipField";
import * as os from "osutil";

class BrandFormPage extends Component {
  state = {};

  static contextTypes = {
    router: PropTypes.object
  };

  handleCancel(id) {
    this.context.router.history.push("/admin/brands");
  }

  handleDeleteClick = () => {
    this.props.actions.deleteBrand(this.props.params.id);
    this.context.router.history.push("/admin/brands");
  };

  handlePriority(id) {
    //this.context.router.history.push("/admin/brands");
  }

  componentWillMount() {
    this.props.actions.fetchBrand(this.props.params.id);
    this.props.actions.fetchBrands();
    this.props.actions.fetchSegments();
    this.props.actions.fetchCategories();
    this.props.actions.fetchPersons();
    this.props.actions.fetchMediagroups();
  }

  handleFormSubmit(event) {
    var data = _.map(this.refs, (r, i) => {
      return { [i]: r.state.value || "" };
    });
    let merged = Object.assign(...data);

    merged.logoUrl = this.refs.logo.state.url || "";
    merged.bgimageUrl = this.refs.bgimage.state.url || "";
    merged.themeimageUrl = this.refs.themeimage.state.url || "";
    merged.categories =
      this.refs.categories.getWrappedInstance().state.value || "";
    merged.disabled = this.refs.disabled.state.value || false;
    this.props.actions.updateBrand(this.props.params.id, merged);
  }

  render() {
    if (!this.props.brand) {
      return null;
    }

    var { mediagroups } = this.props;
    return [
      <RightDrawer key="right">
        <PageBlock label="Medier" >
          <DeleteButton handleClick={this.handleDeleteClick} />              
        </PageBlock>
      </RightDrawer>,
      <Page key="page" ready={!this.props.pending}>
        <Subheader>
          <MenuLink label="Medier" to="/admin/brands" />
          <span className="pathsep" />
          <MenuLink label={this.props.brand.name} to={this.props.params.id} />
        </Subheader>
        <div
          onSubmit={this.handleFormSubmit.bind(this)}
          className="form-inline"
        >
          <PageSection label="Översikt">
            <Row>
              <ToggleField
                style={{ float: "right" }}
                ref="disabled"
                label="Dold"
                value={this.props.brand.disabled}
              />
            </Row>
            <Row>
              <Field
                ref="priority"
                value={this.props.brand.priority}
                floatingLabelText="Prioritet"
              />

              {/* <SelectField ref="priority" value={this.props.brand.priority} floatingLabelText="Prioritet"  >
              <MenuItem value={0} primaryText="0" />
              <MenuItem value={1} primaryText="1" />
              <MenuItem value={2} primaryText="2" />
              <MenuItem value={3} primaryText="3" />
              <MenuItem value={4} primaryText="4" />
              <MenuItem value={5} primaryText="5" />
              <MenuItem value={6} primaryText="6" />
              <MenuItem value={7} primaryText="7" />
              <MenuItem value={8} primaryText="8" />
              <MenuItem value={9} primaryText="9" />
              <MenuItem value={10} primaryText="10" />
              </SelectField> */}
            </Row>
            <Row>
              <DropdownField
                ref="mediagroupid"
                value={this.props.brand.mediagroupid}
                label="Mediehus"
                options={mediagroups}
              />
            </Row>
            <Row>
              <ChipField
                ref="segments"
                value={this.props.brand.segments}
                label="Segment"
                options={this.props.segments}
              />
            </Row>
            <Row>
              <ChipField
                ref="persons"
                value={this.props.brand.persons}
                label="Personer"
                options={this.props.persons}
              />
            </Row>
            <Row>
              <Field
                ref="name"
                value={this.props.brand.name}
                floatingLabelText="Varumärke / namn"
              />
            </Row>
            <Row>
              <Field
                ref="url"
                value={this.props.brand.url}
                floatingLabelText="Hemsida / URL"
              />
            </Row>
            <Row>
              <Field
                ref="subtitle"
                value={this.props.brand.subtitle}
                floatingLabelText="Underrubrik"
              />
            </Row>
            <Row>
              <Field
                ref="description"
                value={this.props.brand.description}
                floatingLabelText="Beskrivning"
                multiLine={true}
              />
            </Row>
          </PageSection>
          <PageSection label="Kanaler">
            <Row>
              <BrandChannelEditor
                brandid={this.props.params.id}
                ref="categories"
                value={this.props.brand.categories}
              />
            </Row>
          </PageSection>
          <PageSection label="Målgrupp">
            <Row>
              <Field
                ref="agemin"
                value={this.props.brand.agemin}
                floatingLabelText="Ålder från"
              />
              <Field
                ref="agemax"
                value={this.props.brand.agemax}
                floatingLabelText="Ålder till"
              />
            </Row>
            <Row>
              <Field
                ref="gendermale"
                value={this.props.brand.gendermale}
                floatingLabelText="Man (procent)"
              />
              <Field
                ref="genderfemale"
                value={this.props.brand.genderfemale}
                floatingLabelText="Kvinna (procent)"
              />
            </Row>
            <Row>
              <Field
                ref="reach"
                value={this.props.brand.reach}
                floatingLabelText="Räckvidd"
              />
            </Row>
            <Row>
              <Field
                ref="targetgroup"
                value={this.props.brand.targetgroup}
                floatingLabelText="Målgruppsbeskrivning"
              />
            </Row>
          </PageSection>
          <PageSection label="Bilder">
            <Row styleName="padded">
              <ImageField
                ref="logo"
                value={this.props.brand.logo}
                url={this.props.brand.logoUrl}
                label="Logotyp, png 400 x 400"
              />
            </Row>
            <Row styleName="padded">
              <ImageField
                ref="themeimage"
                value={this.props.brand.themeimage}
                url={this.props.brand.themeimageUrl}
                label="Temabild liten, jpg 300 x 150"
              />
            </Row>
            <Row styleName="padded">
              <ImageField
                ref="bgimage"
                value={this.props.brand.bgimage}
                url={this.props.brand.bgimageUrl}
                label="Temabild stor, jpg 1500 x 240"
              />
            </Row>

            <Row styleName="padded">
              <RaisedButton
                onTouchTap={this.handleFormSubmit.bind(this)}
                primary={true}
                label="Spara"
              />
              <RaisedButton
                onTouchTap={this.handleCancel.bind(this)}
                label="Stäng"
              />
            </Row>
          </PageSection>
        </div>
      </Page>
    ];
  }
}

function mapStateToProps(state, ownProps) {
  var segments = os.tree_to_array(state.segments.list.data);
  var categories = os.tree_to_array(state.categories.list.data);
  var persons = os.tree_to_array(state.persons.list.data);

  return {
    brand: state.brands.details.data,
    mediagroups: state.mediagroups.list.data,
    segments: segments,
    categories: categories,
    persons: persons,
    pending: state.brands.details.data.pending
  };
}

const mapDispatch = dispatch => {
  return {
    actions: bindActionCreators(
      { ...brands, ...categories, ...segments, ...persons, ...mediagroups },
      dispatch
    )
  };
};
export default connect(mapStateToProps, mapDispatch)(BrandFormPage);



// WEBPACK FOOTER //
// ./src/pages/admin/brands/BrandFormPage.jsx